import React from "react";
import styled from "styled-components";

export default function TwitterDescription() {
  return (
    <ul>
      <ListItem>
        <b>User Registration and Login:</b> Users can create accounts and log in
        using their email and password.
      </ListItem>
      <ListItem>
        <b>Tweeting:</b> Users can create edit and delete tweets.
      </ListItem>
      <ListItem>
        <b>Comments:</b> Users can create and delete post comments.
      </ListItem>
      <ListItem>
        <b>Real-time Notifications:</b> Integration with Firebase provides
        real-time notifications for new tweets and interactions.
      </ListItem>
      <ListItem>
        <b>Responsive Design:</b> The application is fully responsive and
        optimized for different screen sizes.
      </ListItem>
    </ul>
  );
}

const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 8px;
`;
